import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AdminOverview() {
    const [s, setS] = useState({});
    useEffect(() => { api.get("/admin/summary").then((r) => setS(r.data)); }, []);
    const tiles = [
        { k: "players", label: "Players" },
        { k: "coaches", label: "Coaches" },
        { k: "games", label: "Games" },
        { k: "news", label: "News" },
        { k: "sponsors", label: "Sponsors" },
        { k: "sponsor_leads", label: "Sponsor Leads" },
        { k: "sponsor_leads_new", label: "New Leads" },
        { k: "gallery", label: "Gallery" },
        { k: "tryouts", label: "Tryouts" },
        { k: "tryouts_paid", label: "Tryouts Paid" },
        { k: "tickets_paid", label: "Tickets Sold" },
        { k: "tickets_revenue", label: "Ticket Revenue", money: true },
        { k: "contacts", label: "Messages" },
        { k: "newsletter", label: "Subscribers" },
        { k: "users", label: "Users" },
    ];
    return (
        <div data-testid="admin-overview">
            <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-3">Command Room</div>
            <h1 className="h-display text-5xl mb-10">Kingdom Overview</h1>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {tiles.map((t) => (
                    <div key={t.k} className="card-flat p-6" data-testid={`tile-${t.k}`}>
                        <div className="text-[10px] uppercase tracking-widest text-ink">{t.label}</div>
                        <div className="h-display text-5xl text-gold mt-3 leading-none">
                            {t.money ? `$${Number(s[t.k] ?? 0).toFixed(0)}` : (s[t.k] ?? "—")}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
